import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import GigyaManager from "../business/GigyaManager";
import RestManager from "../business/RestManager";
import Tracker from "../business/Tracker";
class DefaultCtrl extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.init();
    }
    init() {
        this.loadChildComponents(this);
        this.switchImage();

        try{
            GigyaManager.getLoggedUserCached().then(()=>{
                Tracker.send("EVENT", {gravitante: true});
            }, ()=>{
                //NOOP
            });
        }catch (err){
            console.log("Error on tracker...")
        }


    }

    goToPlayReceipt(){
        //TODO Mettere blocco orario!
        window.location.href='/promozioni/il-divertimento-e-fuori/gioca-codice'
    }
    switchImage(){


        $('.switch input[type="checkbox"]').click(function(){
            let box = $(this).data('box-ref');
            if($(this).prop("checked") == true){
                let img = $('.' + box).data('img-alt');
                $('.' + box).fadeTo(300, 0, function(){
                    $(this).css({
                        "background-image" : "url("+img+")",
                        "background-repeat" : "no-repeat",
                        "background-size" : "contain"
                    })
                }).fadeTo(300, 1);
            }
            else if($(this).prop("checked") == false){
                let img = $('.' + box).data('img-ref');
                $('.' + box).fadeTo(300, 0, function(){
                    $(this).css({
                        "background-image" : "url("+img+")",
                        "background-repeat" : "no-repeat",
                        "background-size" : "contain"
                    })
                }).fadeTo(300, 1);
            }
        });
    }
}

export default DefaultCtrl;
